// 画像プレビューの処理
imagePreview = {
    // 画像プレビューの処理
    preview: function (dragAndDropAreaSelector, previewAreaSelector) {
        // ドラッグアンドドロップしたときの挙動の定義
        $(dragAndDropAreaSelector).unbind();
        $(dragAndDropAreaSelector).on("dragover", function (ev) {
            ev.preventDefault();
        });

        $(dragAndDropAreaSelector).on("drop", function (ev) {
            ev.preventDefault();
            const files = ev.originalEvent.dataTransfer.files;
            $(".js-upload-file").prop("files", files);
            $(".js-upload-file").trigger("change");
        });

        // プレビュー生成
        $(".js-upload-file").unbind();
        $(".js-upload-file").change(function () {
            //propを使って、file[0]にアクセスする
            const imageObject = $(this).prop("files")[0];

            $(previewAreaSelector).show();
            $(previewAreaSelector + "--no-pic").hide();

            if (
                !/\.(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)$/.test(imageObject.name) ||
                !/(jpg|jpeg|png|gif)$/.test(imageObject.type)
            ) {
                alert("JPG、GIF、PNGファイルの画像を添付してください。");
            } else {
                if (window.FileReader) {
                    const renderObject = new FileReader();
                    renderObject.onload = function () {
                        //Data URI Schemeをimgタグのsrcにいれてリアルタイムに添付画像を描画する
                        $(previewAreaSelector + " img").attr("src", renderObject.result);

                        //削除ボタンがOFFなら削除ボタンを表示
                        $(".js-edit-modal-image-area").show();
                        $(".js-edit-modal-image-upload-area").hide();
                        $(".button-general--modal").removeClass("button-general--disabled");
                        $(".button-general--modal").prop("disabled", false);
                    };
                    renderObject.readAsDataURL(imageObject);
                }
                //画像がアップロードされようとしているので、削除フラグはOFF
                $("[name=deleteImageFlg]").val(false);

                return false;
            }
        });
    },

    // 画像削除が押されたとき
    deleteImage: function (previewAreaSelector) {
        $(previewAreaSelector).hide();
        $(previewAreaSelector + "--no-pic").show();
        $(".js-upload-file").val("");

        $("[name=deleteImageFlg]").val(true);
    }
};
window.imagePreview = imagePreview;
